<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import deFlag from "@/assets/icons/de.svg";
import gbFlag from "@/assets/icons/gb.svg";

const { locale } = useI18n();

const { t } = useI18n();

const showLocaleMenu = ref(false);

const languages = {
  de: {
    name: "Deutsch",
    flag: deFlag,
    url: "https://www.lieferando.de/deals/apple-pay-gutschein-promotion-1/",
  },
  en: {
    name: "English",
    flag: gbFlag,
    url: "https://www.lieferando.de/en/deals/apple-pay-voucher-promotion-1/",
  },
};

const languageTile = computed(() => (locale === "de" ? "Sprache" : "Language"));

function toggleLocaleMenu() {
  showLocaleMenu.value = !showLocaleMenu.value;
}

function changeLocale(newLocale) {
  window.location.href = newLocale;
}
</script>

<template>
  <header class="navbar">
    <div class="logo-container">
      <a
        :href="t('new_customer.logo-link')"
        target="_blank"
        title="Lieferando"
        aria-label="Lieferando"
      >
        <img
          src="@/assets/logo/logo_de_at.svg"
          alt="Lieferando"
          title="Lieferando"
        />
      </a>
    </div>
    <div
      class="select-dropdown"
      @click="toggleLocaleMenu"
      aria-label="Select Language"
    >
      <div :class="`locale-flag ${locale}`"></div>
    </div>
    <div v-show="showLocaleMenu" class="select-menu">
      <div class="list-container">
        <h2>{{ languageTile }}</h2>
        <div class="language-container">
          <p
            v-for="(lang, code) in languages"
            :key="code"
            @click="changeLocale(lang.url)"
          >
            <img :src="lang.flag" :alt="lang.name" />{{ lang.name }}
          </p>
        </div>
      </div>
    </div>
  </header>
</template>
<style scoped>
.navbar {
  padding: 13px 24px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.04),
    0 8px 12px -2px rgba(0, 0, 0, 0.06), 0 4px 6px 0 rgba(0, 0, 0, 0.04);
  z-index: 1;
  position: relative;
  background-color: #f36805;
}

.logo-container {
  max-width: 188px;
  max-height: 55px;
  display: block;
}

.logo-container img {
  width: 100%;
  height: auto;
}

.select-dropdown {
  cursor: pointer;
  z-index: 1005;
  position: absolute;
  top: 15px;
  right: 24px;
  display: block;
  margin: 0;
  padding: 0;
  width: 28px;
  height: 28px;
}

.select-dropdown .locale-flag.de:before {
  content: "";
  position: absolute;
  background: url("@/assets/icons/de.svg") no-repeat 50%;
  background-size: cover;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 4px solid #fff;
  cursor: pointer;
}

.select-dropdown .locale-flag.en:before {
  content: "";
  position: absolute;
  background: url("@/assets/icons/gb.svg") no-repeat 50%;
  background-size: cover;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 4px solid #fff;
  cursor: pointer;
}

.select-menu {
  background: #fff;
  z-index: 1006;
  position: absolute;
  right: 24px;
  top: 70px;
  margin-top: 0;
  border-radius: 20px;
  padding: 8px 0 24px 0;
  width: 152px;
  cursor: pointer;
  transform: translateZ(0);
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.05);
  font-family: "JETSansVF2", Arial, sans-serif;
}

.select-menu h2 {
  font-size: 18px;
  font-weight: 700;
}

.list-container {
  float: left;
  padding: 0 24px;
  min-width: 200px;
}

.language-container {
  display: flex;
  flex-direction: column;
}

.language-container p {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.language-container p:hover {
  color: #f36805;
}

.language-container img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #fff;
  object-fit: cover;
}

@media (max-width: 922px) {
  .logo-container {
    max-width: 150px;
    max-height: 44px;
  }
}
</style>
